import { render, staticRenderFns } from "./passwordLogin.vue?vue&type=template&id=eb015b1c&scoped=true"
import script from "./passwordLogin.vue?vue&type=script&lang=js"
export * from "./passwordLogin.vue?vue&type=script&lang=js"
import style0 from "./passwordLogin.vue?vue&type=style&index=0&id=eb015b1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb015b1c",
  null
  
)

export default component.exports